export const ENUM_TICKET_STATUS = {
    AGUARDANDO_PAGAMENTO: 'AGUARDANDO_PAGAMENTO',
    COBRANCA_GERADA: 'COBRANCA_GERADA',
    EXPIRADO: 'EXPIRADO',
    PAGO: 'PAGO',
    CANCELADO: 'CANCELADO',
    ESTORNADO: 'ESTORNADO',
}